import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { OtaInfoComponent } from '../ota-info/ota-info.component';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';

@Component({
  selector: 'app-ota-batch-list',
  templateUrl: './ota-batch-list.component.html',
  styleUrls: ['./ota-batch-list.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    MatIcon,
    MatTooltip,
    NgxPaginationModule,
    DatePipe,
    CommonSearchComponent,
    CommonPaginationComponent,
    DecimalPipe,
    IndianNumberPipe,
    OtaInfoComponent,
  ],
})
export class OtaBatchListComponent implements OnInit {
  uid = '';
  size = 10;
  page = 1;
  search = '';
  listOfBatch = [];
  totalLength = 0;
  deviceOTAForm: FormGroup = this.formBuilder.group({});
  userPermission = [];

  deleteOta = false;
  viewOtaBatch = false;
  createOta = false;
  viewOtaMaster = false;
  viewManualOta = false;
  exportData = [];
  isDownloading = false;

  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };
  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.setDeviceOtaForm();
    this.checkPermission();
    this.syncInitialDownloadState();
    if (this.viewOtaBatch) {
      if (this.route.snapshot.paramMap.get('uid')) {
        this.uid = this.route.snapshot.paramMap.get('uid') || '';

        sessionStorage.setItem('pageNoOTABatchList', this.page.toString());
        sessionStorage.setItem('sizeOTABatchList', this.size.toString());

        this.deviceOTAForm?.get('batchListSearch')?.setValue(this.uid);
        this.search = this.deviceOTAForm?.get('batchListSearch')?.value;
        sessionStorage.setItem('searchOTABatchList', this.search);
      }
      this.fetchBatchList();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'OTA Batch' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'OTA Batch' && element.view === true) {
          this.viewOtaBatch = true;
        }
        if (element.pageName === 'OTA Batch' && element.delete === true) {
          this.deleteOta = true;
        }
        if (element.pageName === 'OTA Batch' && element.create === true) {
          this.createOta = true;
        }
        if (element.pageName === 'OTA Master' && element.view === true) {
          this.viewOtaMaster = true;
        }
        if (element.pageName === 'Manual OTA' && element.view === true) {
          this.viewManualOta = true;
        }
      }
    );
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  setDeviceOtaForm() {
    this.deviceOTAForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  fetchBatchList() {
    this.spinner.show();
    let page = 1;
    if (parseInt(sessionStorage.getItem('pageNoOTABatchList') || '0')) {
      page = parseInt(sessionStorage.getItem('pageNoOTABatchList') || '0');
    } else {
      sessionStorage.setItem('pageNoOTABatchList', page.toString());
    }
    this.page = page;

    let size = 10;
    if (parseInt(sessionStorage.getItem('sizeOTABatchList') || '0')) {
      size = parseInt(sessionStorage.getItem('sizeOTABatchList') || '0');
    } else {
      sessionStorage.setItem('sizeOTABatchList', size.toString());
    }
    this.size = size;

    this.apiMicroservice
      .getBatchData(this.page, this.size, this.search)
      .subscribe((res) => {
        if (res.status) {
          this.listOfBatch = res.data.batchDeviceData;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
          this.spinner.hide();
        } else {
          this.apiMicroservice.openSnackbar('Something went wrong');
          this.spinner.hide();
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    sessionStorage.setItem('pageNoOTABatchList', this.page.toString());
    this.fetchBatchList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    sessionStorage.setItem('pageNoOTABatchList', this.page.toString());
    this.size = event;
    sessionStorage.setItem('sizeOTABatchList', this.size.toString());
    this.fetchBatchList();
  }

  onSearch(event: string) {
    this.page = 1;
    sessionStorage.setItem('pageNoOTABatchList', this.page.toString());
    this.search = event;
    this.deviceOTAForm?.get('batchListSearch')?.setValue(this.search);
    sessionStorage.setItem('searchOTABatchList', this.search);
    this.fetchBatchList();
  }

  deleteOtaBatchDetails(_id: string) {
    if (confirm('Are you sure to Abort the batch?')) {
      this.spinner.show();
      const abortedBy = this.apiMicroservice.decryptData(
        sessionStorage.getItem('userRefId') || ''
      );
      this.apiMicroservice.deleteOtaBatch(_id, abortedBy).subscribe({
        next: (res) => {
          if (res.status) {
            this.spinner.hide();
            this.apiMicroservice.openSnackbar('Batch Aborted Successfully');
            this.ngOnInit();
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          const example = ERROR.error.message;
          this.apiMicroservice.openSnackbar(example);
          this.ngOnInit();
        },
      });
    }
  }

  downloadOtaBatchDevicesReport(_id: string) {
    if (confirm('Do want to download this batch details?')) {
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      // Call to download batch data
      this.apiMicroservice.downloadOtaBatchDevicesReport(_id).subscribe({
        next: (res) => {
          try {
            if (res?.status && res.fileDownloadUrl) {
              // window.open(res.fileDownloadUrl, '_blank');
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.apiMicroservice.openSnackbar('File ready for download');
            } else {
              this.apiMicroservice.openSnackbar(
                res?.message || 'File URL not available'
              );
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          const example =
            ERROR.error.message ||
            'Download failed. Please contact server team.';
          this.apiMicroservice.openSnackbar(example);
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
    }
  }

  manualOTANew() {
    sessionStorage.setItem('otaDeviceHistoryImei', '');
    this.redirect('manual-ota');
  }

  showBatchDetails(batchId: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/ota-batch-view', batchId])
    );
    const fullUrl = window.location.origin + url;

    // Open the URL in a new tab
    window.open(fullUrl, '_blank');
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
